import { render, staticRenderFns } from "./Me.vue?vue&type=template&id=68f8111a"
import script from "./Me.vue?vue&type=script&lang=js"
export * from "./Me.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports